module.exports = __webpack_public_path__ + "img/logo.a94f0bc6.svg";